import axios from "axios";
import { HideListItemModel } from "models";
import { IAPIResult } from "models/interfaces";

export async function list() {
  // await Utils.sleep(300);
  const response = await axios.get<IAPIResult<HideListItemModel[]>>(
    "/api.d/v1/ec/hide-list/list"
  );
  return response.data;
}

export async function create(name: string, list: { corp_id: string }[]) {
  // await Utils.sleep(300);
  const data = {
    hide_list_name: name,
    hide_corp_list: list.map((v) => {
      return { hide_corp_id: v.corp_id };
    }),
  };
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/hide-list/create",
    data
  );
  return response.data;
}

export async function update(
  id: string,
  name: string,
  list: { corp_id: string }[]
) {
  // await Utils.sleep(300);
  const data = {
    hide_list_id: id,
    hide_list_name: name,
    hide_corp_list: list.map((v) => {
      return { hide_corp_id: v.corp_id };
    }),
  };
  const response = await axios.put<IAPIResult>(
    "/api.d/v1/ec/hide-list/update",
    data
  );
  return response.data;
}

export async function detail(id: string) {
  // await Utils.sleep(300);
  const response = await axios.get<IAPIResult<HideListItemModel>>(
    "/api.d/v1/ec/hide-list/detail",
    { params: { hide_list_id: id, hide_corp_name: "" } }
  );
  return response.data;
}

export async function del(id: string) {
  // await Utils.sleep(300);
  const response = await axios.delete<IAPIResult>(
    "/api.d/v1/ec/hide-list/delete",
    {
      data: {
        hide_list_id: id,
      },
    }
  );
  return response.data;
}
